export default {
  data() {
    return {
      searchSchema: [
        {
          label: '管理员名称',
          itemName: 'name',
          type: 'input',
          allowClear: true,
        },
        {
          label: '管理员ITcode',
          itemName: 'username',
          type: 'input',
          allowClear: true,
        },
        {
          label: '管理员状态',
          itemName: 'status',
          type: 'select',
          selectList: [
            { text: '激活', value: '1' },
            { text: '冻结', value: '2' },
          ],
          allowClear: true,
        },
      ],
      searchData: {
        name: '',
        username: '',
        status: '',
      },
      columns: [
        {
          title: '序号',
          width: 70,
          dataIndex: 'order',
          fixed: 'left',
          align: 'center',
          customRender: (text, record, index) =>
            (this.pageData.current - 1) * this.pageData.pageSize + (index + 1),
          // scopedSlots: { customRender: 'order'}
        },
        {
          title: '管理员名称',
          dataIndex: 'name',
          width: 100,
        },
        {
          title: '管理员ITcode',
          dataIndex: 'username',
          width: 120,
        },
        {
          title: '最近登录时间',
          dataIndex: 'loginTime',
          width: 120,
          align: 'center',
        },
        {
          title: '最近登录IP',
          dataIndex: 'clientIp',
          width: 120,
        },
        {
          title: '所属角色',
          dataIndex: 'roleNames',
          width: 150,
          ellipsis: true,
          align: 'left',
          scopedSlots: { customRender: 'roleNames' },
          //customRender: text => text.join(',')
        },
        {
          title: '所属部门',
          align: 'center',
          dataIndex: 'department',
          width: 80,
          scopedSlots: { customRender: 'department' },
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: 70,
          align: 'center',
          scopedSlots: { customRender: 'status' },
          //customRender: text => (text == 1 ? '激活' : '冻结')
        },
        {
          title: '添加时间',
          dataIndex: 'createTime',
          align: 'center',
          width: 150,
        },
        {
          title: '操作',
          fixed: 'right',
          width: 100,
          dataIndex: 'action',
          slotName: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
    }
  },
}
